// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Burger_wrapper__3AVvJ","dark":"Burger_dark__1EFLK","open":"Burger_open__1B72_","inner":"Burger_inner__DOtlz"};